import { ChangeDetectionStrategy, ChangeDetectorRef, Component, InjectionToken, inject } from "@angular/core";

export const RECORD_INFO_DATA = new InjectionToken<{
    name: string;
    text?: string;
    readOnly?: boolean;
    lastAuthor?: string;
    lastChange?: string;
}>("RECORD_INFO_DATA");

@Component({
    selector: "info-record",
    templateUrl: "./info-record.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InfoRecordComponent {
    protected _changesDetector = inject(ChangeDetectorRef);
    protected config = inject<{
        name: string;
        text?: string;
        lastAuthor?: string;
        lastChange?: string;
    }>(RECORD_INFO_DATA, { optional: true });

    data: { name: string; text?: string; lastAuthor?: string; lastChange?: string } | null = null;

    constructor() {
        this.data = this.config;
    }
}
